import { useEffect, useState } from "react"

type ToggleType = [boolean, () => void];

export const useToggle = (initValue: boolean = false): ToggleType => {
    const [state, setState] = useState<boolean>(initValue);
    const toggle = () => setState(!state);
    return [state, toggle];
}

export const useWindowSize = () => {
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    })

    useEffect(() => {
        const handleResize = () => {
            setSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }

        window.addEventListener('resize', handleResize, false);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return size;
}

export const useRandom = <E>(samples: E[]): E => samples[Math.floor(Math.random() * samples.length)];
